module.exports = __webpack_public_path__ + "img/upload-icon.f3c77a89.png";